import { NgModule, inject } from '@angular/core';
import { CanMatchFn, RouterModule, Routes } from '@angular/router';
import { LogoutComponent } from './auth/logout/logout.component';
import { AuthService } from './shared/services/auth/auth.service';

const cargarMembresiaPago = () =>
  import('./membresia-pago/membresia-pago.module').then((m) => m.MembresiaPagoModule);

/** Solo coincide sin sesión; con sesión, /membresia la atiende el layout autenticado. */
const sinSesion: CanMatchFn = () => !inject(AuthService).isLoggedIn();

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'signup',
    loadChildren: () =>
      import('./auth/registro-usuario/registro-usuario.module').then((m) => m.RegistroUsuarioModule),
  },
  { path: 'logout', component: LogoutComponent },
  // Respuesta de PayPhone. Pública a propósito: quien paga desde la app llega sin sesión.
  // Va antes de las rutas del layout (ThemeRoutingModule) para no cargar el header,
  // que redirige a /login cuando no hay sesión.
  { path: 'membresia/pago', loadChildren: cargarMembresiaPago },
  // Cancelación desde PayPhone sin sesión: mensaje en vez de mandar al login.
  { path: 'membresia', canMatch: [sinSesion], loadChildren: cargarMembresiaPago },
  { path: '', redirectTo: 'mi-casillero', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
